const tryFmt = new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", minimumFractionDigits: 2, maximumFractionDigits: 2 });
const moneyFmts = {};
const empty = (v) => v === null || v === undefined || Number.isNaN(Number(v));

export const formatTRY = (v) => (empty(v) ? "—" : tryFmt.format(Number(v)));

export const formatMoney = (v, currency = "TRY") => {
  if (empty(v)) return "—";
  if (currency === "TRY") return formatTRY(v);
  moneyFmts[currency] = moneyFmts[currency] || new Intl.NumberFormat("tr-TR", { style: "currency", currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return moneyFmts[currency].format(Number(v));
};

export const formatPct = (v, digits = 1) =>
  empty(v) ? "—" : new Intl.NumberFormat("tr-TR", { style: "percent", minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(v) / 100);

export const formatNumber = (v, digits = 0) =>
  empty(v) ? "—" : new Intl.NumberFormat("tr-TR", { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(v));

export const formatRate = (v) => formatNumber(v, 4);

export const formatDate = (iso, withTime = true) => {
  if (!iso) return "—";
  const d = new Date(iso);
  const opts = { day: "2-digit", month: "2-digit", year: "numeric", ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}) };
  return new Intl.DateTimeFormat("tr-TR", opts).format(d);
};

export const formatIsoDay = (s) => (s ? s.split("-").reverse().join(".") : "—");

export const imgSrc = (url) => (!url ? undefined : url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

export const formatBalance = (v) => (empty(v) ? "—" : `${tryFmt.format(Math.abs(Number(v)))} ${Number(v) > 0 ? "(B)" : Number(v) < 0 ? "(A)" : ""}`.trim());
